import React, { useState } from 'react';
import '../blogs.module.css'
import { useHistory } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPen, faTrashAlt} from '@fortawesome/pro-light-svg-icons';
import DeleteBlogModal from './DeleteBlogModal';



const AdminOverflow = ({id, urlTitle}) => {
    const history = useHistory();

    const [showDelete, setShowDelete] = useState(false);

    const toggleDelete = () => {setShowDelete(!showDelete)}

    return (
        <div className='adminOverflow'>
            <div className='overflowOption' onClick={()=>{
                history.push(`${urlTitle}/edit`);
            }}>
                Edit
            </div>
            <div className='overflowOption' onClick={toggleDelete}>
                Delete
            </div>
            {showDelete && <DeleteBlogModal open={showDelete} toggle={toggleDelete} id={id}/>}
        </div>
    )
}

export default AdminOverflow;


// WEBPACK FOOTER //
// ./src/components/Blogs/Admin/AdminOverflow.js